module.exports = __webpack_public_path__ + "img/conservative-practitioner-1.32d683cc.svg";